export const data = [
  {
    id: 1,
    club: 'APFC',
    opposition: 'OFFC',
    goalsScored: 4,
    goalsConceded: 2,
    goals: 1,
    assists: 1,
    rating: 7
  },
  {
    id: 2,
    club: 'APFC',
    opposition: 'OOFC',
    goalsScored: 1,
    goalsConceded: 2,
    goals: 0,
    assists: 0,
    rating: 5
  },
  {
    id: 3,
    opposition: 'PBFC',
    club: 'MNF',
    goalsScored: 1,
    goalsConceded: 0,
    goals: 0,
    assists: 1,
    rating: 8
  },
  {
    id: 4,
    opposition: 'WFC',
    club: 'TNF',
    goalsScored: 1,
    goalsConceded: 1,
    goals: 1,
    assists: 0,
    rating: 6
  },
  {
    id: 5,
    opposition: 'HFC',
    club: 'APFC',
    goalsScored: 5,
    goalsConceded: 1,
    goals: 2,
    assists: 1,
    rating: 9
  },
  {
    id: 6,
    opposition: 'WGFC',
    club: 'MNF',
    goalsScored: 3,
    goalsConceded: 2,
    goals: 0,
    assists: 2,
    rating: 6
  },
  {
    id: 7,
    opposition: 'HFC',
    club: 'APFC',
    goalsScored: 6,
    goalsConceded: 2,
    goals: 3,
    assists: 1,
    rating: 6
  },
  {
    id: 8,
    opposition: 'KAFC',
    club: 'TNF',
    goalsScored: 1,
    goalsConceded: 2,
    goals: 0,
    assists: 0,
    rating: 7
  },
]